import { BreakPriceLine } from '../../../../components/displays/charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/exitTactics/BreakPriceLine';
import { BreakPriceTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/individualTacticPanels/exits/BreakPriceTacticPanel';
import { AddBreakPriceTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/panels/tacticsPanel/addTacticPanel/individualAddTacticPanels/breakPrice/AddBreakPriceTacticPanel';
import { BreakPriceWrapper } from '../../../../components/displays/tradeplans/softOrderModules/exitTacticModules/BreakPriceModule/wrapper/BreakPriceWrapper';
import BreakPriceDocs from '../../../../components/forms/tradeplans/documentation/BreakPriceDocumentation';
import BreakPriceModule from '../../../../components/forms/tradeplans/tradingPlanFormComponents/FieldComponents/exitTactics/modules/BreakPriceModule';
import { UnderlyingBreakPriceData } from './underlyingBreakPriceData';
import { validateUnderlyingBreakPrice } from './validateUnderlyingBreakPrice';

export const UnderlyingBreakPrice = {
  //data class
  dataStore: UnderlyingBreakPriceData,

  //string constants
  name: 'UNDERLYING_BREAK_PRICE',
  tacticLabel: 'Underlying Break Price',
  addTacticLabel: 'Add Underlying Break Price',
  category: 'Exit',

  // components
  tradePlanFormModule: BreakPriceModule,
  tacticPanel: BreakPriceTacticPanel,
  addTacticPanel: AddBreakPriceTacticPanel,
  wrapper: BreakPriceWrapper,
  chartSoftOrderComponent: BreakPriceLine,
  documentation: BreakPriceDocs,
  alertDetailsComponent: null,

  //functions
  setupDetailParser: null,
  validationFunction: validateUnderlyingBreakPrice,
};
